<template>

    <v-card >
        <v-card-title>{{$t('simulacion.modulo.fotovoltaica.titulo')}}</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
            <v-row>
            <v-col cols="12">
                
                <v-container>
                    <!--
                    <v-form v-model="valid" lazy-validation>
                    <v-row>
                        <v-col v-for="(value, key) in datos" :key="key" cols="12" sm="3">

                        <v-text-field v-if="!campos_ocultos.includes(key)"
                            density="compact"  
                            variant="outlined" 
                            :label="formatLabel(key)"
                            v-model.number="datos[key]"
                            :type="getFieldType(key)"                            
                            :hint="getHint(key)"
                            @input="updateValue" 
                        ></v-text-field>
                        </v-col>
                    </v-row>
                    </v-form>
                    -->
                    

                    <v-row>
                      <!--
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexf')"
                            v-model.number="datos['capexf']"
                            type="number"                            
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('capexv')"
                            v-model.number="datos['capexv']"
                            type="number"                            
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>
                      <v-col cols="3" sm="3">
                        <v-text-field
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('opex')"
                            v-model.number="opex"
                            type="number"                            
                            @input="updateValue" 
                        ></v-text-field>
                      </v-col>-->
                      <v-col cols="3" sm="3">
                        <v-text-field
                        :disabled="this.disabled"
                            density="compact"
                            rounded='sm'
                            variant="outlined"
                            :label="formatLabel('degrad')"
                            :model-value="formatNumber(degrad)"
                            @update:modelValue="val => degrad = Number(val.replace(',', '.'))"
                                                        
                            @input="updateValue" 
                            :rules="[rules.Negativo]"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="3" sm="3">
                        <v-typography variant="h1">
                          {{ $t('simulacion.modulo.electrolizador.datos_economicos') }}
                        </v-typography>                                              
                      </v-col>
                    </v-row>
                    <v-row>
                    <v-col cols="6" sm="6">
                      <v-switch
                      :readonly="this.disabled"
                      :class="{ 'switch-disabled-look': this.disabled }"
                        v-model="usarCurvasBOP"
                        :label="$t('simulacion.modulo.curvas_CAPEXOPEX.capex_opex_curvas')"
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                      />
                    </v-col>
                     <v-col cols="6" sm="6">
                      <v-switch
                      :readonly="this.disabled"
                      :class="{ 'switch-disabled-look': this.disabled }"
                      v-if="!usarCurvasBOP"
                        v-model="usarOpexAnual"
                        :label="$t('simulacion.modulo.curvas_CAPEXOPEX.opex_anual') "
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                      />
                    </v-col>
                  </v-row>
                    <v-row v-if="!usarCurvasBOP">
                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX
                        :disabled="this.disabled"
                        :titulo="$t('simulacion.modulo.fotovoltaica.capex')"
                        v-model:valorVariable="datos.capexv"
                        v-model:valorFijo="datos.capexf"
                        unidad-variable="kEUR/MW"
                        unidad-fijo="kEUR"
                         />
                      </v-col>


                      <v-col cols="3" sm="3"  v-if="!usarOpexAnual">
                        <ComponenteEditorCAPEXOPEX 
                        :disabled="this.disabled"
                        :titulo="$t('simulacion.modulo.fotovoltaica.opex')"
                        v-model:valorVariable="datos.opexv"
                        v-model:valorFijo="datos.opexf"
                        unidad-variable="kEUR/MW año"
                        unidad-fijo="kEUR año"

                        />
                      </v-col>
                    <!--
                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX titulo="Capex BOP (EUR/MW fotovoltaica):"/>
                      </v-col>

                      <v-col cols="3" sm="3">
                        <ComponenteEditorCAPEXOPEX titulo="Capex Reemplazo stacks (EUR/MW):"/>
                      </v-col>
                      -->  
                    </v-row>  
                    <v-row>
                    <v-col cols="12" sm="6">
                      <v-switch
                      :readonly="this.disabled"
                      :class="{ 'switch-disabled-look': this.disabled }"
                        v-model="usarCurvasConexion"
                        :label="usarCurvasConexion ? $t('simulacion.modulo.ejecucion.switch.conexion') : $t('simulacion.modulo.ejecucion.switch.conexion')"
                        inset
                        hide-details
                        color="blue"         
                        track-color="grey"
                      />
                    </v-col>
                  </v-row>

                  <v-row v-if="usarCurvasConexion">
                    <v-col cols="12" sm="6" md="4">
                      <ComponenteEditorCAPEXOPEX
                      :disabled="this.disabled"
                        :titulo="$t('simulacion.modulo.fotovoltaica.capexcel')"
                        v-model:valorVariable="datos.capexvcel"
                        v-model:valorFijo="datos.capexfcel"
                        unidad-variable="kEUR/MW"
                        unidad-fijo="kEUR"
                      />
                    </v-col>
                    <v-col cols="12" sm="6" md="4">
                      <ComponenteEditorCAPEXOPEX
                      :disabled="this.disabled"
                        :titulo="$t('simulacion.modulo.fotovoltaica.opexcel')"
                        v-model:valorVariable="datos.opexvcel"
                        v-model:valorFijo="datos.opexfcel"
                        unidad-variable="kEUR/MW año"
                        unidad-fijo="kEUR año"
                      />
                    </v-col>
                  </v-row>         


                </v-container>

            </v-col>
            </v-row>
            <v-row>
                      <v-col cols="12">
                      
                      <div v-if="!usarCurvasBOP && usarOpexAnual">
                        <ComponenteInputMatrizAnual
                        :title="$t('simulacion.modulo.curvas_CAPEXOPEX.opex_anual_title')"
                        :disabled="this.disabled"
                        :modelValue="this.modelValue.senda_opex"
                        :years="this.years"
                         nombre_tabla="OPEX"
                        :nombres_fila="['Fijo','Variable']"
                        :nombres_tabla="{
                          'fijo':$t('simulacion.modulo.curvas_CAPEXOPEX.fijo_units'),
                          'variable':$t('simulacion.modulo.curvas_CAPEXOPEX.variable_units'),
                        }"
                        @update:modelValue="this.$emit('update:modelValue', {
                                                ...this.modelValue,
                                                senda_opex: $event
                                              });"
                        />

                       
                      </div>
                       </v-col>
                  </v-row>
                  <v-row>
                  <v-col cols="12">
                    <div>
                      <ComponenteInputMatrizAnual
                    :title="$t('simulacion.modulo.curvas_CAPEXOPEX.precio_transferencia_interno')"
                    :disabled="this.disabled"
                    :modelValue="sendaPCPV"
                    :years="this.years"
                    nombre_tabla="Precio transferencia interno fotovoltaica"
                    :nombres_fila="['precio']"
                    :nombres_tabla="{
                      'precio': 'EUR/MWh',
                    }"
                    @update:modelValue="actualizarSendaPCPV"
                  />
                    </div>
                  </v-col>
                </v-row>
        </v-card-text>
    </v-card>



</template>

<script>
import ComponenteEditorCAPEXOPEX from '../components/ComponenteEditorCAPEXOPEX.vue';
import ComponenteInputMatrizAnual from './ComponenteInputMatrizAnual.vue';
export default {
  props: {
    disabled:{
      type:Boolean,
      default:false
    },
    modelValue: { // Recibe el valor desde el padre
      type: Object,
      required: true,
    },
      years:{
    type:Array,
    required:true
  },
    usarCapexOpexGeneralFotovoltaica: String
  },
  components:{
    ComponenteEditorCAPEXOPEX,
    ComponenteInputMatrizAnual
  },
  data() {
    return {
      valid: false,
      datos: { ...this.modelValue,
         capexfcel: this.modelValue?.capexfcel ?? 0,
      capexvcel: this.modelValue?.capexvcel ?? 0,
      opexfcel:  this.modelValue?.opexfcel  ?? 0,
      opexvcel:  this.modelValue?.opexvcel  ?? 0,
        curvas_conexion: {
        capex: this.modelValue?.curvas_conexion?.capex ?? 0,
        opex:  this.modelValue?.curvas_conexion?.opex  ?? 0,
      }, // Inicializa los datos con el valor recibido
      },
      labels: {
        pmax: this.$t('simulacion.modulo.fotovoltaica.pmax'),
        capexf: this.$t('simulacion.modulo.fotovoltaica.capexf'),
        capexv: this.$t('simulacion.modulo.fotovoltaica.capexv'),
        opex: this.$t('simulacion.modulo.fotovoltaica.opex'),
        degrad: this.$t('simulacion.modulo.fotovoltaica.degrad'),
        ppvfija: this.$t('simulacion.modulo.fotovoltaica.ppvfija'),
      },
      campos_ocultos: ["ppvfija","pmax"],

      rules: {
        required: v => !!v || 'This field is required',
        Negativo: (v) => {
        const num = Number(v.toString().replace(',', '.'));
          return isNaN(num) ? 'Valor inválido' : (num >= 0 ? true : 'El valor no puede ser negativo');
        },
      },
      usarCapexOpexGeneral: this.usarCapexOpexGeneralFotovoltaica || 'especifico'
    };
  },


  computed: {
    sendaPCPV() {
      const years = Array.isArray(this.years) ? this.years.map(Number) : [];
      const base = Array.isArray(this.modelValue?.senda_pcpv)
        ? this.modelValue.senda_pcpv
        : [];

      return years.map(anio => {
        const existente = base.find(x => Number(x?.anio) === anio);

        return {
          anio,
          precio: Number(existente?.precio ?? 0),
        };
      });
    },
    usarOpexAnual: {
      get() {
        return this.datos.opex_anual === 1 
      },
      set(val) {
        console.log("usarOpexAnual Val ", val)
        this.datos.opex_anual = val ? 1 : 0;
        console.log("this.datos.curvas.opex_anual ", this.datos.opex_anual)
      }
    },

    opex: {
      get() {        
        const value = this.datos.opex 
        return (value * 100).toFixed(2)               
      },
      set(value) {        
        const numericValue = value / 100;
        this.datos.opex = isNaN(numericValue) ? 0 : numericValue;
      },
    },


    degrad: {
      get() {        
        const value = this.datos.degrad 
        return (value * 100).toFixed(2)               
      },
      set(value) {        
        const numericValue = value / 100;
        this.datos.degrad = isNaN(numericValue) ? 0 : numericValue;
      },
    },
    usarCurvasBOP: {
      get() {
        return this.datos.curvas?.capex === 1 && this.datos.curvas?.opex === 1;
      },
      set(val) {
        this.datos.curvas.capex = val ? 1 : 0;
        this.datos.curvas.opex = val ? 1 : 0;
      }
    },
usarCurvasConexion: {
    get() {
      return this.datos.curvas_conexion?.capex === 1 && this.datos.curvas_conexion?.opex === 1;
    },
    set(v) {
      this.datos.curvas_conexion.capex = v ? 1 : 0;
      this.datos.curvas_conexion.opex  = v ? 1 : 0;
       // Si apagamos el switch, reseteamos los valores
    if (!v) {
      this.datos.capexfcel = 0
      this.datos.capexvcel = 0
      this.datos.opexfcel  = 0
      this.datos.opexvcel  = 0
    }
    }
    },
  },


  watch: {
    // Vigila los cambios en `datos` y emite el evento cuando cambian
    datos: {
      handler(newDatos) {
        this.$emit('update:modelValue', newDatos);
      },
      deep: true, // Escucha los cambios profundos dentro de `datos`
    },


    '$i18n.locale'() {    
      
      this.labels.pmax = this.$t('simulacion.modulo.fotovoltaica.pmax')
      this.labels.capexf = this.$t('simulacion.modulo.fotovoltaica.capexf')
      this.labels.capexv = this.$t('simulacion.modulo.fotovoltaica.capexv')
      this.labels.opex = this.$t('simulacion.modulo.fotovoltaica.opex')
      this.labels.degrad = this.$t('simulacion.modulo.fotovoltaica.degrad')
      this.labels.ppvfija = this.$t('simulacion.modulo.fotovoltaica.ppvfija')

    },



  },
  methods: {
  actualizarSendaPCPV(nuevaSenda) {
  this.datos.senda_pcpv = nuevaSenda;

  this.$emit('update:modelValue', {
    ...this.modelValue,
    senda_pcpv: nuevaSenda,
  });
},
    actualizarDatos(){

        this.datos= { ...this.modelValue,
         capexfcel: this.modelValue?.capexfcel ?? 0,
         senda_pcpv: this.modelValue?.senda_pcpv ?? [],
      capexvcel: this.modelValue?.capexvcel ?? 0,
      opexfcel:  this.modelValue?.opexfcel  ?? 0,
      opexvcel:  this.modelValue?.opexvcel  ?? 0,
        curvas_conexion: {
        capex: this.modelValue?.curvas_conexion?.capex ?? 0,
        opex:  this.modelValue?.curvas_conexion?.opex  ?? 0,
      }, // Inicializa los datos con el valor recibido
      }

      },
    
    formatNumber(value) {
      if (value === null || value === undefined || value === '') return '';
      if (typeof value !== 'number') value = Number(value);

      // Si es entero, no ponemos decimales
      if (Number.isInteger(value)) {
        return value.toString().replace('.', ',');
      } else {
        // Si tiene decimales, mostramos con coma
        return value.toString().replace('.', ',');
      }
    },
    formatLabel(key) {
      let out = key.charAt(0).toUpperCase() + key.slice(1)
      out = this.labels[key]
      return out;
    },
    getFieldType(key) {
      if (key === 'capac' || key === 'capex' || key === 'nfijo') {
        return 'number';
      }
      return 'text';
    },
    getHint(key) {
      if (key === 'capex') {
        return 'In currency';
      }
      return '';
    },
    saveData() {
      console.log('Data saved:', this.datos);
    },
    emitirOpcionGeneral() {
      this.$emit('update:usarCapexOpexGeneralFotovoltaica', this.usarCapexOpexGeneral);
    }
  },
};
</script>

<style scoped>
.v-btn {
  margin-top: 20px;
}
</style>
